// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-MwtIdN","content":"content-MJi5bl","image":"image-XfyZ0l","link":"link-LCKpIw"};